var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        staticClass: "mt-4",
        attrs: { actions: _vm.headerActionConfig, page: _vm.pageOptions }
      }),
      _c("board", { staticClass: "mb-4", attrs: { details: _vm.boardData } }),
      _c(
        "validation-observer",
        { ref: "insertSpaceRef", attrs: { novalidate: "", tag: "form" } },
        [
          _c(
            "div",
            [
              _c("section-title", {
                attrs: {
                  "has-line": "",
                  title: "Información de Espacio Disponible"
                }
              }),
              _c("div", { staticClass: "main-box col-md-12 mb-3" }, [
                _c("i", { staticClass: "fas fa-bell-exclamation" }),
                _c("span", [
                  _vm._v(
                    " Nota: De contar con mas de una compañía debe seleccionar una primero para luego seleccionar la fecha y continuar con la creación de espacios. "
                  )
                ])
              ]),
              _c("div", { staticClass: "row ml-2" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-date-picker", {
                                staticClass: "w-100",
                                attrs: {
                                  "custom-error-msg": "Campo requerido.",
                                  disabled:
                                    _vm.disabledDate && !_vm.model.isEditMode,
                                  error: errors[0],
                                  label: "Fecha:",
                                  "max-date": _vm.maxDate,
                                  "min-date": _vm.minStartDate,
                                  placeholder: "DD/MM/YYYY"
                                },
                                model: {
                                  value: _vm.model.startDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "startDate", $$v)
                                  },
                                  expression: "model.startDate"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    }),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-7" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-gray-6 font-14 font-weight-normal mb-2"
                            },
                            [_vm._v(" Hora Desde: ")]
                          ),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-input", {
                                          staticClass: "hour-size",
                                          attrs: {
                                            "custom-error-msg": "",
                                            disabled:
                                              _vm.disabledDate &&
                                              !_vm.model.isEditMode,
                                            error: errors[0],
                                            "mask-type": "Day",
                                            type: "text"
                                          },
                                          on: { input: _vm.evalEnterHour },
                                          model: {
                                            value: _vm.model.startDateHour,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "startDateHour",
                                                $$v
                                              )
                                            },
                                            expression: "model.startDateHour"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("span", { staticClass: "mx-2 mt-1" }, [
                                _vm._v(":")
                              ]),
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-input", {
                                          staticClass: "hour-size",
                                          attrs: {
                                            "custom-error-msg": "",
                                            disabled:
                                              _vm.disabledDate &&
                                              !_vm.model.isEditMode,
                                            error: errors[0],
                                            "mask-type": "Day",
                                            type: "text"
                                          },
                                          on: { input: _vm.evalEnterMinute },
                                          model: {
                                            value: _vm.model.startDateMinute,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "startDateMinute",
                                                $$v
                                              )
                                            },
                                            expression: "model.startDateMinute"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("b-form-select", {
                                staticClass: "ampm-size ml-3",
                                attrs: {
                                  disabled:
                                    _vm.model.ampmDisabled ||
                                    (_vm.disabledDate && !_vm.model.isEditMode),
                                  options: _vm.catalog.timeOptions
                                },
                                on: { input: _vm.evalEnterAmPm },
                                model: {
                                  value: _vm.model.startDateAmPm,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "startDateAmPm", $$v)
                                  },
                                  expression: "model.startDateAmPm"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.hourValidation
                            ? _c("error", {
                                attrs: {
                                  message: _vm.hourValidation,
                                  variant: "no-border"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        clearable: false,
                                        "custom-error-msg":
                                          "Favor de seleccionar la duración",
                                        disabled:
                                          _vm.disabledDate &&
                                          !_vm.model.isEditMode,
                                        error: errors[0],
                                        fieldkey: "value",
                                        fieldname: "text",
                                        label: "Duración:",
                                        options: _vm.catalog.durations,
                                        placeholder: "Seleccione"
                                      },
                                      on: { input: _vm.onDurationChange },
                                      model: {
                                        value: _vm.model.duration,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "duration", $$v)
                                        },
                                        expression: "model.duration"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "mt-4" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "color-gray-6 font-14 font-weight-normal mb-2"
                          },
                          [_vm._v(" Hora Hasta: ")]
                        ),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-input", {
                                        staticClass: "hour-size",
                                        attrs: {
                                          "custom-error-msg": "",
                                          disabled:
                                            _vm.disabledDate &&
                                            !_vm.model.isEditMode,
                                          error: errors[0],
                                          "mask-type": "Day",
                                          type: "text"
                                        },
                                        on: { input: _vm.evalEnterEndDate },
                                        model: {
                                          value: _vm.model.endDateHour,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "endDateHour",
                                              $$v
                                            )
                                          },
                                          expression: "model.endDateHour"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            }),
                            _c("span", { staticClass: "mx-2 mt-1" }, [
                              _vm._v(":")
                            ]),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-input", {
                                        staticClass: "hour-size",
                                        attrs: {
                                          "custom-error-msg": "",
                                          disabled: _vm.disabledDate,
                                          error: errors[0],
                                          "mask-type": "Day",
                                          type: "text"
                                        },
                                        on: { input: _vm.evalEnterEndDate },
                                        model: {
                                          value: _vm.model.endDateMinute,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "endDateMinute",
                                              $$v
                                            )
                                          },
                                          expression: "model.endDateMinute"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            }),
                            _c("b-form-select", {
                              staticClass: "ampm-size ml-3",
                              attrs: {
                                disabled:
                                  _vm.model.endDateAmPmDisabled ||
                                  (_vm.disabledDate && !_vm.model.isEditMode),
                                options: _vm.catalog.timeOptions
                              },
                              model: {
                                value: _vm.model.endDateAmPm,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "endDateAmPm", $$v)
                                },
                                expression: "model.endDateAmPm"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.hourValidation
                          ? _c("error", {
                              attrs: {
                                message: _vm.hourValidation,
                                variant: "no-border"
                              }
                            })
                          : _vm._e(),
                        _vm.isMultipleCreation
                          ? _c(
                              "div",
                              { staticClass: "service-warning-container" },
                              [
                                _c("error", {
                                  attrs: {
                                    "is-alert-mode": "",
                                    message:
                                      "De acuerdo a la selección de horarios se estarán creando espacios disponibles en bloques.",
                                    variant: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "mt-4" },
                      [
                        _c("check-box", {
                          staticClass: "checkbox",
                          attrs: { text: "Recurrencia" },
                          on: { input: _vm.onChangeRecurrence },
                          model: {
                            value: _vm.model.recurrence,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "recurrence", $$v)
                            },
                            expression: "model.recurrence"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-4 mt-4" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-drop-down", {
                                attrs: {
                                  clearable: false,
                                  "custom-error-msg": "Campo requerido.",
                                  disabled:
                                    _vm.catalog.companies.length === 1
                                      ? true
                                      : false,
                                  error: errors[0],
                                  fieldkey: "id",
                                  fieldname: "name",
                                  label: "Compañía:",
                                  options: _vm.catalog.companies,
                                  placeholder: "Seleccione"
                                },
                                on: { input: _vm.onChangeCompany },
                                model: {
                                  value: _vm.model.company,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "company", $$v)
                                  },
                                  expression: "model.company"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    }),
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-drop-down", {
                                staticClass: "mt-3",
                                attrs: {
                                  clearable: false,
                                  "custom-error-msg": "Campo requerido.",
                                  error: errors[0],
                                  fieldkey: "id",
                                  fieldname: "name",
                                  label: "Municipio:",
                                  options: _vm.catalog.municipalities,
                                  placeholder: "Seleccione"
                                },
                                on: { input: _vm.onChangeMunicipality },
                                model: {
                                  value: _vm.model.municipality,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "municipality", $$v)
                                  },
                                  expression: "model.municipality"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    }),
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-drop-down", {
                                staticClass: "mt-3",
                                attrs: {
                                  clearable: false,
                                  "custom-error-msg": "Campo requerido.",
                                  error: errors[0],
                                  fieldkey: "specialistLocationId",
                                  fieldname: "locationName",
                                  label: "Lugar de Servicio:",
                                  options: _vm.catalog.serviceLocations,
                                  placeholder: "Seleccione"
                                },
                                on: { input: _vm.onChangeServiceLocation },
                                model: {
                                  value: _vm.model.serviceLocation,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "serviceLocation", $$v)
                                  },
                                  expression: "model.serviceLocation"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-4 mt-4" },
                  [
                    _c(
                      "div",
                      { staticClass: "bg-secondary-9 rounded p-3 mt-2" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "color-secondary-6 font-weight-normal font-16 border-bottom mx-3 mb-4"
                          },
                          [_vm._v(" Disciplinas ")]
                        ),
                        _vm._l(_vm.catalog.serviceTypes, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: `license-row-${index}`,
                              staticClass: "ml-3 c-checkbox"
                            },
                            [
                              _c("check-box", {
                                staticClass: "checkbox",
                                attrs: { text: item.name },
                                model: {
                                  value: item.value,
                                  callback: function($$v) {
                                    _vm.$set(item, "value", $$v)
                                  },
                                  expression: "item.value"
                                }
                              })
                            ],
                            1
                          )
                        }),
                        _vm.catalog.serviceTypes.length == 0
                          ? _c("div", { staticClass: "text-center" }, [
                              _vm._v(" No hay información disponible. ")
                            ])
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm.disciplineValidation === true
                      ? _c("error", {
                          attrs: {
                            message:
                              "Debe seleccionar al menos una disciplina.",
                            variant: "no-border"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm.model.recurrence
            ? _c(
                "div",
                [
                  _c("section-title", {
                    staticClass: "mt-5",
                    attrs: { "has-line": "", title: "Recurrencia" }
                  }),
                  _c("recurrence-date", {
                    staticClass: "c-recurrenceDate",
                    attrs: { "start-date": _vm.model.startDate },
                    on: { input: _vm.onChangeOcurrences }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }